import { Component, OnInit } from '@angular/core';
import { MasterService,ClassroomService ,FrontOffService} from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-marksgen',
  templateUrl: './marksgen.component.html',
  styleUrls: ['./marksgen.component.scss'],
  providers:[MasterService,ClassroomService,FrontOffService]
})
export class MarksgenComponent implements OnInit {

  memberdetails:any[]=[];
  classdetails:any[]=[];
  arrashead:any=[];
  arrevpaternsub:any=[];
  arrastype:any=[];
  closeResult: string;
  classes: any=[];
  section: any=[];
  arrcourse:any=[];
  arrsubcomb:any=[];
  student:boolean=true;
  staff:boolean=false;
  memberdash:any={};
  objass:any={};
  objupload:any={};
  objfilt:any={};
  objfilt1:any={};
  objfilt2:any={};
  objfilt3:any={};
  arreval:any=[];
  arrevpatern:any=[];
  arrstulist:any=[]
  objmarks:any={};
  objmarks1:any={}
  arrevpatern1:any=[];
  arrcat:any=[{name:'Board'},{name:'Competitive'}];
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  fileToUpload: File = null;

fData: FormData = new FormData;

  constructor(private http: HttpClient, private cservice: ClassroomService,private fservice: FrontOffService, private mservice: MasterService,private modalService: NgbModal) { }

  ngOnInit(): void {
this.  Getsubcomb();
    this.masasshead();
    this.masasstype();
    this.getcourses();

  }


  Getsubcomb()
  {
    debugger
    this.mservice.sel_sp_exmsubcomb()
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      this.objfilt3.sucbid=resultArray[0].sucbid;
      //this.clsdate=resultArray;
      this.arrsubcomb = resultArray;
      this.getevpattern();
      },
     error => console.log("Error :: " + error)
  )
  }
   
  
  masasshead() {
    this.mservice.sel_sp_masasshead()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrashead = resultArray;
            this.objfilt.asid=resultArray[0].asid;
            this.objfilt1.asid=resultArray[0].asid;
            this.objfilt2.asid=resultArray[0].asid;
            this.objfilt3.asid=resultArray[0].asid;
           // this.fmodel.assid=resultArray[0].asid;
           this.masasstype();
        },
        error => console.log("Error :: " + error)
        )
  }
  masasstype() {
    this.mservice.sel_sp_masasstype()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrastype = resultArray;
            this.objfilt.astpid=resultArray[0].astpid;
            this.objfilt1.astpid=resultArray[0].astpid;
            this.objfilt2.astpid=resultArray[0].astpid;
            this.objfilt3.astpid=resultArray[0].astpid;
            this.getevpattern();
           // this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }

  getevpattern() {

    console.log('objfilt',this.objfilt);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    this.cservice.sel_evaluationentry(this.objfilt.asid,this.objfilt.astpid,"selectcnt")
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrevpatern = resultArray;
            this.arrevpatern.map(function(entry) {
              entry.enblregen = false;
            
              return entry;
          });
           // this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }

  getevpatternbyclass() {

    console.log('objfilt',this.objfilt1);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    //this.cservice.sel_evaluationentry(this.objfilt1.asid,this.objfilt1.astpid,"selectclcnt")
    this.cservice.sel_evaluationentry(this.objfilt1.asid,this.objfilt1.astpid,"selectcrcnt")
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrevpatern1 = resultArray;
           // this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }

  generate(objdata,oprtype)
  {
    if(confirm(" Are you sure you wan't to "+oprtype))
    {
      objdata.oprtype=oprtype;
     // objdata.clid=this.objfilt.clid;
     // objdata.crid=this.objfilt.crid;
     // objdata.sucbid=this.objfilt.sucbid;
      objdata.asid=this.objfilt.asid;
      objdata.astpid=this.objfilt.astpid;

      this.saveevpattern(objdata);
    }
  }


  generate_student(objdata,oprtype)
  {
    if(confirm(" Are you sure you wan't to "+oprtype))
    {
      objdata.oprtype=oprtype;
     // objdata.clid=this.objfilt.clid;
     // objdata.crid=this.objfilt.crid;
     // objdata.sucbid=this.objfilt.sucbid;
      objdata.asid=this.objfilt2.asid;
      objdata.astpid=this.objfilt2.astpid;

      this.genforstudent(objdata);
    }
  }

  generate_subject(objdata,oprtype)
  {
    if(confirm(" Are you sure you want to "+oprtype))
    {
      objdata.oprtype=oprtype;
     // objdata.clid=this.objfilt.clid;
     // objdata.crid=this.objfilt.crid;
     // objdata.sucbid=this.objfilt.sucbid;
    

      this.genforsubject(objdata);
    }
  }
  updatedet(objdata,oprtype)
  {
    
      objdata.oprtype=oprtype;
      objdata.clid=this.objfilt.clid;
      objdata.crid=this.objfilt.crid;
      objdata.sucbid=this.objfilt.sucbid;
      objdata.asid=this.objfilt.asid;
      objdata.astpid=this.objfilt.astpid;
      this.saveevpattern(objdata);
    
  }

  saveevpattern(objdata) {

    console.log('objdata',objdata);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    this.cservice.generatemarks(objdata)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            alert(resultArray.message);
            this.getevpattern();
        },
        error => console.log("Error :: " + error)
        )
  }

  genforstudent(objdata) {

    console.log('objdata',objdata);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    this.cservice.generatemarksstu(objdata)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            alert(resultArray.message);
            this.getevpattern();
        },
        error => console.log("Error :: " + error)
        )
  }



  genforsubject(objdata) {

    console.log('objdata',objdata);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    this.cservice.generatemarkssub(objdata)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            alert(resultArray.message);
            this.getevldatasubject();
        },
        error => console.log("Error :: " + error)
        )
  }

  delsubject(objdata) {
if(confirm("Are you sure you want to delete"))
{
    console.log('objdata',objdata);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    this.cservice.delmarkssub(objdata)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            alert(resultArray.message);
            this.getevldatasubject();
        },
        error => console.log("Error :: " + error)
        )
  }}
  downloadmarksheet(clid,scid,asid,astpid,crid,sucbid){
    debugger
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.cservice.callurl+"export/marksheet.php?clcd="+clcd+"&aycd="+aycd+"&asid="+asid+"&astpid="+astpid+"&clid="+clid+"&scid="+scid+"&crid="+crid+"&sucbid="+sucbid;
  
    // window.open(url,'','_blank');
    window.open(url);
   }


   openmarks(content,obj)
   {
    
this.objmarks=obj;
   
     this.modalOptions = {
       backdrop:'static',
       backdropClass:'customBackdrop',
       size:'sm'
      }
     this.modalRef=this.modalService.open(content,this.modalOptions);
     
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           //this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
   }
   

   openmarks1(content,obj)
   {
    
this.objmarks1=obj;
this.objmarks1.maxscore="0";
this.objmarks1.minscore="0";
this.objmarks1.asid=this.objfilt.asid;
this.objmarks1.astpid=this.objfilt.astpid;
   
     this.modalOptions = {
       backdrop:'static',
       backdropClass:'customBackdrop',
       size:'sm'
      }
     this.modalRef=this.modalService.open(content,this.modalOptions);
     
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           //this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
   }
   



   openinfo(content,clid,scid,crid,sucbid)
   {
    
    this.objupload.clid=clid;
    this.objupload.scid=scid;
    this.objupload.asid=this.objfilt1.asid;
    this.objupload.astpid=this.objfilt1.astpid;
    this.objupload.crid=crid;
    this.objupload.sucbid=sucbid;
   
     this.modalOptions = {
       backdrop:'static',
       backdropClass:'customBackdrop',
       size:'lg'
      }
     this.modalRef=this.modalService.open(content,this.modalOptions);
     
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           //this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
   }
   

   upload(files: FileList) {
    debugger;
    this.fileToUpload = files.item(0);
  
   
  }
  

  masclass() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            this.objfilt2.clid=resultArray[0].clid;
            this.objfilt3.clid=resultArray[0].clid;
            this.massection();
        },
        error => console.log("Error :: " + error)
        )
  }

  private getcourses() {

    this.mservice.getcourse()
  .subscribe((result:any) => {
  
  this.arrcourse=result;
  this.objfilt2.crid=result[0].crid;
  this.objfilt3.crid=result[0].crid;
  this.masclass();
  
  }, error => {
  
  //alert('error in r');
  // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
  }
  );
    
    
  }

  massection() {
    this.mservice.massection()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.section = resultArray;
            this.objfilt2.scid=resultArray[0].scid;
            this.getstudentsdata();
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  getstudentsdata() {
    this.fservice.getstudents_clwise(this.objfilt2.clid,this.objfilt2.scid,this.objfilt2.crid)
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrstulist = resultArray;
            
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getevldatasubject() {

    console.log('objfilt',this.objfilt3);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    this.mservice.sel_evlmarks_subject(this.objfilt3)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrevpaternsub = resultArray;
           // this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }

  updatemaxmin() {

    console.log('objfilt',this.objmarks);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    if(confirm("Are you sure you want to update marks?"))
    {
    this.mservice.updatemaxmin(this.objmarks)
        .subscribe(
          result => {
            console.log('getdashcounts', result);
            alert(result.message);
            if(result.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
             this.getevldatasubject();
  
            
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        )
  }}
 

  updatemaxmin1() {

    console.log('objfilt',this.objmarks1);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    if(confirm("Are you sure you want to update marks?"))
    {
    this.mservice.updatemaxmin1(this.objmarks1)
        .subscribe(
          result => {
            console.log('getdashcounts', result);
            alert(result.message);
            if(result.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
             this.getevpattern();
  
            
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        )
  }}
 


  showhidescores(obj,tag,asid,astpid) {

   // console.log('objfilt',this.objmarks1);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    if(confirm("Are you sure, you want to proceed?"))
    {
      if(obj.stuid == undefined)
      {
        obj.stuid="0";
      }
      obj.hide=tag;
      obj.asid=asid;
      obj.astpid=astpid;
    this.mservice.showhidescores(obj)
        .subscribe(
          result => {
            console.log('getdashcounts', result);
            alert(result.message);
            if(result.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
             this.getevpattern();
  
            
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        )
  }}
  fileupload()
  {
  debugger
  
  console.log('file data',JSON.stringify(this.fileToUpload));
  
  this.cservice.uploadphoto(this.fileToUpload,this.objupload)
  .subscribe(fresult => {
     // console.log('ret',JSON.stringify(fresult));
      alert (fresult.message);
      if(fresult.status=='Success')
  {
  // let localmodref=this.modalRef;
  // localmodref.close();
  //this.Refreshsummary();
  this.fileToUpload=null;
  // this.dcid=0;
  // this.disuploadbtn=true;
  // this.photo=fresult.updfilepath;
  
  }
      
  }, error => 
  alert('error in connection')
  
  );
  
  
  
  }
      

}
